import { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import { Container } from 'react-bootstrap';
import { LandscapeBasicInfoOrganism } from '../../organisms';
import LandscapeBaseEditTemplate from '../../../templates/LandscapeBaseEditTemplate';
import { LandscapeResponseV3Dto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-response-v3.dto';
import { UpdateInitiativeDto } from '../../../store/landscapeAPI/landscape/dto/request/update-initiative-dto';
import { InsertInitiativeDTOV3 } from '../../../store/landscapeAPI/landscape/dto/request/insert-initiative.dto';

export interface LandscapeBasicInformationEditTemplateProps {
  landscape: Map<string, LandscapeResponseV3Dto>;
  callbackFn: (
    landscape: InsertInitiativeDTOV3 | UpdateInitiativeDto,
    languageCode: string,
    translateToAllLanguages: boolean
  ) => void;
  onDeleteClick: () => void;
}

const LandscapeBasicInformationEditTemplate: FC<
  LandscapeBasicInformationEditTemplateProps
> = ({ landscape, callbackFn, onDeleteClick }) => {
  return (
    <BaseTemplate>
      <Container>
        <LandscapeBaseEditTemplate>
          <LandscapeBasicInfoOrganism
            landscape={landscape}
            isEdit
            callbackFn={callbackFn}
            onDeleteClick={onDeleteClick}
          />
        </LandscapeBaseEditTemplate>
      </Container>
    </BaseTemplate>
  );
};

export default LandscapeBasicInformationEditTemplate;
